export default {"src":"/_next/static/media/water_24.a7e429e7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};